import { Trash } from "lucide-react";
import React, { useEffect, useState } from "react";

const BASE = "https://webhook.harmonyalgo.com/api";

const Row = ({ item, deleteEntry, formatDate }) => {
  return (
    <tr
      key={item.id}
      className="hover:bg-zinc-800/50 transition-colors"
    >
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        {item.label}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-100">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zinc-800 text-zinc-100 border border-zinc-700">
          {item.payment_link}
        </span>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        {formatDate(item.created_at)}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-zinc-400">
        <button
          className="mr-4 p-1 bg-red-500 text-white text-sm rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500"
          onClick={() => deleteEntry(item.id)}
        >
          <Trash />
        </button>
      </td>
    </tr>
  );
};

const Whitelist = ({ formatDate }) => {
  const [tableData, setTableData] = useState([]);
  const [inputs, setInputs] = useState({})

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`${BASE}/payment_links`);
      const resJson = await res.json();
      setTableData(resJson);
    };
    fetchData();
  }, []);

  const handlechange = (event) => {
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  const handleSubmit = async () => {
    const res = await fetch(`${BASE}/register_payment_link`, {
      method: "POST",
      body: JSON.stringify(inputs),
      headers: { "Content-Type": "application/json" },
    });
    const resJson = await res.json();
    console.log(resJson)
    setTableData([...tableData, resJson])
  }

  const deleteEntry = async (id) => {
    const res = await fetch(`${BASE}/delete_payment_link`, {
      method: "POST",
      body: JSON.stringify({ id }),
      headers: { "Content-Type": "application/json" },
    });
    const resJson = await res.json();
    console.log(resJson)
    setTableData(tableData.filter((item) => item.id !== id))
  }

  return (
    <div className="rounded-lg border border-zinc-800 bg-zinc-900">
      <div className="w-3/4 p-6 pb-10">
        <div className="flex gap-4 items-center justify-between">
          <input
            type="text"
            name="label"
            value={inputs.label}
            placeholder="Enter label..."
            className="block px-4 py-2 w-full bg-zinc-800 text-zinc-100 border border-zinc-700 rounded-md focus:outline-none focus:ring-2 focus:ring-zinc-600 focus:border-zinc-600 placeholder-zinc-400"
            onChange={handlechange}
          />
          <input
            type="text"
            name="payment_link"
            value={inputs.payment_link}
            placeholder="Enter payment link (plink_xxxx)..."
            className="block px-4 py-2 w-full bg-zinc-800 text-zinc-100 border border-zinc-700 rounded-md focus:outline-none focus:ring-2 focus:ring-zinc-600 focus:border-zinc-600 placeholder-zinc-400"
            onChange={handlechange}
          />
          <button
            className="w-48 mr-4 px-4 py-2 bg-teal-500 text-white text-md rounded hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 border border-teal-500"
            onClick={handleSubmit}
          >Add</button>
        </div>
      </div>

      {/* Tablo */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-zinc-800">
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Label
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Payment Link
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Created At
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-800">
            {tableData.map((item) => (
              <Row
                item={item}
                deleteEntry={deleteEntry}
                formatDate={formatDate}
              />
            ))}
            {tableData.length ? null : (
              <td className="m-4 px-1 py-4 whitespace-nowrap text-sm text-zinc-100">
                No items.
              </td>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export { Whitelist }


